import { createFileRoute } from '@tanstack/react-router'
import { useProjectDetail } from '~/components/projects/project-detail'
import { ProjectPanel } from '~/components/projects/project-panel'

/** The Overview — what a project (or a lead) opens on. */
const ProjectOverviewRoute = () => {
  const project = useProjectDetail()

  return <ProjectPanel project={project} />
}

export const Route = createFileRoute('/_authenticated/$workspaceSlug/projects/$projectId/')({
  component: ProjectOverviewRoute,
})
